(function ($) {
    $(document).ready(function () {
        // Listen file
        $(".uploadWrapping").each(function () {
            var that = $(this);
            that.find(".uploadErrorsWrapping").html("").hide();
            // Initialize the jQuery File Upload plugin
            that.fileupload({
                url: urls.upload,
                // This element will accept file drag/drop uploading
                dropZone: that,
                // This function is called when a file is added to the queue;
                // either via the browse button, or via drag/drop:
                add: function (e, data) {
                    var file = data.files[0];
                    var name = file.name;
                    var title = file.name
                        .beforeLastIndex(".")
                        .replace(/_/gi, " ");
                    var type = file.type;
                    var size = sizeFormat(file.size);
                    var extension = getFileExtension(file.name);
                    var type_allow = "";
                    var add_text = "";

                    if (that.find(".uploadFileType").val() === "file") {
                        type_allow = conf.file_type_allow;
                    } else if (that.find(".uploadFileType").val() === "image") {
                        type_allow = conf.image_type_allow;
                        add_text = "写真は ";
                    } else {
                        let conf_allow = conf.image_type_allow.split(",").indexOf(extension.toLowerCase());
                        if (conf_allow == 1) {
                            type_allow = conf.image_type_allow;
                            add_text = "写真は ";
                        } else if (conf_allow == 0) {
                            type_allow = conf.file_type_allow;
                        }
                    }

                    if (
                        type_allow &&
                        type_allow
                            .split(",")
                            .indexOf(extension.toLowerCase()) == -1
                    ) {
                        let message_error = 'ファイルをアップロードしてください。';
                        if (that.find(".uploadFileType").val() === "file") {
                            message_error = 'ファイルをアップロードしてください。';
                        }
                        that.find(".uploadErrorsWrapping")
                            .html(
                                add_text +
                                    type_allow.toUpperCase() + message_error
                            )
                            .show();
                        return;
                    }

                    var store_name = that.data("storeinput");
                    var maxSize = that.find(".uploadFileInput").attr("data-maxsize");

                    let file_max_size = 1024;
                    if(maxSize) {
                        max_size = file_max_size * maxSize;
                    }
                    if (
                        Number((file.size / file_max_size).toFixed(2)) >=
                        max_size
                    ) {
                        let max_size_error = 'MB以下アップロードしてください。';
                        if (that.find(".uploadFileType").val() === "file") {
                            max_size_error = 'MB以下アップロードしてください。';
                        }
                        that.find(".uploadErrorsWrapping")
                            .html(maxSize + max_size_error)
                            .show();
                        return;
                    }

                    var formData = {};
                    formData._token = $('input[name="_token"]').val();
                    // formData.table = $('input[name="table"]').val();
                    // formData.resize = $('input[name="resize"]').val();
                    formData.path = that.find(".uploadFilePath").val();
                    formData.rename = that.find(".uploadFileRename").val();
                    formData.type_file = that.find(".uploadFileType").val();
                    data.formData = formData;
                    that.find(".uploadPreview").attr("src", "/assets/img/loading.gif");
                    // Automatically upload the file once it is added to the queue
                    var jqXHR = data.submit();
                },
                done: function (e, data) {
                    var store_name = that.data("storeinput");

                    var input = that.find('input[name="' + store_name + '"]');
                    input.val(data.result.path);

                    if (that.find(".uploadFileType").val() === "file") {
                        that.find(".uploadPreview").attr(
                            "src",
                            "/assets/img/icon_pdf.png"
                        );
                        var originalName = data.result.path.replace(/temp|project|storage|\//g, "")
                        that.find(".originalName").html(
                            '<a href="'+data.result.path+'" target="_blank">'+originalName+'</a>'
                        );
                        initNameFile(store_name, data.result.file, data.result.path)

                        //$("#originalName").text(data.result.file);
                    } else if (that.find(".uploadFileType").val() === "image") {
                        that.find(".uploadPreview").attr(
                            "src",
                            data.result.path
                        );
                        if (
                            navigator.userAgent.indexOf("MSIE") != -1 ||
                            !!document.documentMode == true
                        ) {
                            objectFitIE(".jsObjectFitIE");
                        }
                    } else {
                        var extension = getFileExtension(
                            data.result.original_name
                        );
                        if (
                            conf.image_type_allow
                                .split(",")
                                .indexOf(extension.toLowerCase()) != -1
                        ) {
                            that.find(".uploadPreview").attr(
                                "src",
                                data.result.path
                            );
                            if (
                                navigator.userAgent.indexOf("MSIE") != -1 ||
                                !!document.documentMode == true
                            ) {
                                objectFitIE(".jsObjectFitIE");
                            }
                        } else if (
                            conf.file_type_allow
                                .split(",")
                                .indexOf(extension.toLowerCase()) == 0
                        ) {
                            that.find(".uploadPreview").attr(
                                "src",
                                "/assets/img/icon_pdf.png"
                            );
                            that.find(".originalName").text(
                                data.result.original_name
                            );
                        }
                    }
                    that.find(".uploadRemoveBtn").css("display", "");
                    that.find(".uploadErrorsWrapping").html("");
                },

                fail: function (e, data) {
                    if(data.jqXHR.status == 403) {
                        alert('ファイルの形式が正しくありません。');
                        that.find(".uploadPreview").attr(
                            "src",
                            "/assets/img/expert/profile/icon_default.jpg"
                        );
                    } else {
                        var fail = JSON.parse(data.jqXHR.responseText);
                        if (fail.errors.file) {
                            var thumb = '/assets/img/img_thumb_pdf.jpg'
                            if (that.find('.uploadFileType').val() === 'image') {
                                thumb = '/assets/img/expert/profile/icon_default.jpg'
                            }
                            that.find(".uploadPreview").attr('src', thumb);
                            that.find(".originalName").text("");
                            that.find(".uploadErrorsWrapping")
                                .html(fail.errors.file)
                                .show();
                        }
                    }
                },
            });
        }); // END dropZoneUpload

        // Event upload new file
        $(".uploadWrapping").on("click", ".uploadAddBtn", function () {
            $(this).parents(".uploadWrapping").find(".uploadFileInput").click();
        });

        // Remove photo
        $(".uploadWrapping").delegate(".uploadRemoveBtn", "click", function () {
            var that        = $(this).parents(".uploadWrapping");
            var store_name  = that.data("storeinput");
            var page        = that.data("page")
            var input       = that.find('input[name="' + store_name + '"]');
            if (input.val()) {
                if(store_name == 'csv_file' && that.find(".uploadFileType").val() === "file") {
                    $('#originalName').text("");
                    $("#saveImportDataCSV").attr("data-submit", false);
                    $("#saveImportDataCSV").attr("data-error", false);
                }
                if (that.find(".uploadFileType").val() === "file") {
                    that.find(".uploadPreview").attr(
                        "src",
                        "/assets/admin/img/admin/img_thumb_pdf.jpg"
                    );
                    that.find(".originalName").text("");
                } else if (that.find(".uploadFileType").val() === "image") {
                    that.find(".uploadPreview").attr(
                        "src",
                        (page == 'order_company' ? "/assets/img/expert/profile/icon_corp_default.jpg" : "/assets/img/expert/profile/icon_default.jpg")
                    );
                } else {
                    that.find(".uploadPreview").attr(
                        "src",
                        "/assets/admin/img/admin/img_thumb_pdf.jpg"
                    );
                    that.find(".originalName").text("");
                }
                input.val("");
            }
            that.find(".uploadErrorsWrapping").html("");
            that.find(".uploadRemoveBtn").css("display", "none");
        });
        function objectFitIE(className) {
            $(className).each(function () {
                var $el = $(this),
                    $img = $el.children("img"),
                    src = $img.attr("src");
                if ($el.hasClass("imgContain")) {
                    $el.addClass("IE");
                } else {
                    $el.addClass("IE").css({
                        "background-image": "url(" + src + ")",
                    });
                    $img.hide();
                }
            });
        }

        function initNameFile(value, file, path) {
            let html = '';
            switch(value) {
                case 'attached_document_1':
                case 'attached_document_2':
                case 'attached_document_3':
                case 'attached_document_4':
                case 'attached_document_5':
                    let result = value.replace("attached_document_", "");
                    html = '<a href="'+path+'" target="_blank">'+file+'</a>';
                    $("#originalName"+result).html(html);
                    break;
                default:
                    html = '<a href="'+path+'" target="_blank">'+file+'</a>';
                    $("#originalName").html(html);
                    break;
            }
        }

    });
})(jQuery); // END jQuery

// Helper function that formats the file sizes
function sizeFormat(bytes) {
    if (typeof bytes !== "number") {
        return "";
    }
    if (bytes >= 1000000000) {
        return (bytes / 1000000000).toFixed(2) + " GB";
    }
    if (bytes >= 1000000) {
        return (bytes / 1000000).toFixed(2) + " MB";
    }
    return (bytes / 1000).toFixed(2) + " KB";
}

function getFileExtension(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
}
